module.exports = __webpack_public_path__ + "img/radio4.252235b4.png";